module.exports = __webpack_public_path__ + "img/ellipse.635817c4.svg";